import React, { CSSProperties } from 'react';

import './Avatar.scoped.scss';

interface Props {
  src: string;
  variant?: 'small' | 'normal' | 'large';
  containerStyle?: CSSProperties;
  imageStyle?: CSSProperties;
}

const Avatar: React.FC<Props> = ({ src, variant = 'normal', containerStyle, imageStyle }) => {
  return (
    <div className={`avatar ${variant}`} style={containerStyle}>
      <img src={src} style={imageStyle} alt="avatar" />
    </div>
  );
};

export default Avatar;
